module.exports = __webpack_public_path__ + "img/img (19).015feb54.jpg";